// this module is deprecated in favor of `airship/modules/report-error`
const reportError = require('../report-error').default

module.exports = legacyErrorReporter

function legacyErrorReporter(err, culprit, extra = {}) {
  reportError(err, {...extra, culprit, sentViaDeprecatedReporter: true})
}
